import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Lottie from 'react-lottie';

import * as Telemetry from '../../backend/telemetry.js';
import * as Routing from '../../backend/reducers/routing';
import * as SessionReducer from '../../backend/reducers/session-reducer';
import Email from '../../components/svgs/Email.jsx';
import Reload from '../../components/svgs/Reload.jsx';
import Button from '../../components/button/Button.jsx';
import animation from '../../ext/error-page-animations/error-page.json';
import { ERRORCODES } from '../../backend/constants';

import styles from './ErrorPage.module.scss';

const mailToUrl = 'mailto:support@locuslabs.com?subject=VMS Error';
const baseErrorMessage = 'Oops, something went wrong';
const errorCodes = ERRORCODES;
const { UPDATE_ENTITY_ERROR, VENUE_NOT_FOUND, UNKNOWN_ERROR } = errorCodes;
const errorMap = {
    [UNKNOWN_ERROR]: '',
    [VENUE_NOT_FOUND]: 'Venue not found for user account',
    [UPDATE_ENTITY_ERROR]: '',
};
const animationOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
};

const getErrorCodeMessage = error =>
    !errorMap[error] ? (
        baseErrorMessage
    ) : (
        <React.Fragment>
            {baseErrorMessage}
            <div className={styles.errorDescription}>{errorMap[error]}</div>
        </React.Fragment>
    );

const errorCodeToUrl = error => (Object.values(errorCodes).includes(error) ? `${mailToUrl}(Error code: ${error})` : mailToUrl);

const ErrorPage = () => {
    const error = useSelector(Routing.Selectors.getLocationError);
    const { email: userEmail } = useSelector(SessionReducer.Selectors.getUserData);
    const dispatch = useDispatch();

    const handleClick = () => {
        Telemetry.recordReloadVenuesButtonClick(userEmail);
        window.open(errorCodeToUrl(error));
    };

    const navigateToVenues = () => {
        Telemetry.recordEmailSupportButtonClick(userEmail);
        dispatch(Routing.Actions.goToVenues());
    };

    return (
        <div className={styles.errorsPageContainer}>
            <div className={styles.errorMessageBody}>
                <div className={styles.errorImage}>
                    <Lottie options={animationOptions} height={430} width={360} isPaused={false} />
                </div>
                <div className={styles.text}>{getErrorCodeMessage(error)}</div>
                <div className={styles.buttonsContainer}>
                    <Button onClick={navigateToVenues} label="Reload Venues" color="blue">
                        <Reload />
                    </Button>
                    <Button onClick={handleClick} label="Email Support" color="clear-with-border">
                        <Email />
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
